import { Component, ElementRef, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { FiltersService } from 'app/shared/services/data/filters.service';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-input-filter',
  templateUrl: './input-filter.component.html',
  styleUrls: ['./input-filter.component.scss']
})
export class InputFilterComponent implements OnDestroy {
  private searchSubject = new Subject<any[]>()

  @ViewChild('searchInput') public searchInput: ElementRef<HTMLInputElement>

  @Input() public data: any[]
  @Output() public search = new EventEmitter<any[]>()

  constructor(
    private filtersService: FiltersService
  ) {
    this.searchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(value => {
      this.search.emit(value)
    })
  }

  ngOnDestroy(): void {
    this.filtersService.clearFiltersAndText()
  }

  public searchByText(event: MouseEvent): void {
    const inputElement: HTMLInputElement = event.target as HTMLInputElement

    const words = inputElement.value

    const filteredData = this.filtersService.filterByText(words, this.data)

    this.searchSubject.next(filteredData)
  }

  public clearInput(input: HTMLInputElement): void {
    input.value = ''

    const filteredData = this.filtersService.filterByText('', this.data)

    this.searchSubject.next(filteredData)
  }

  public getValue(): string {
    const inputElement = this.searchInput.nativeElement as HTMLInputElement

    return inputElement.value
  }

  public setValue(value: string): void {
    const inputElement = this.searchInput.nativeElement as HTMLInputElement

    inputElement.value = value
  }

  public clearValue(): void {
    const inputElement = this.searchInput.nativeElement as HTMLInputElement

    inputElement.value = ''
  }
}
